import { createContext } from 'preact'
import { useContext } from 'preact/hooks'
import type { SolaDatabase } from './db'

/**
 * The open database connection.
 *
 * Provided once at the root after a successful boot, so no component needs to
 * open its own connection or handle the migration gate. `useDatabase` throws
 * rather than returning undefined: reaching a data component without a
 * connection is a wiring bug, not a runtime condition to render around.
 */
const DatabaseContext = createContext<SolaDatabase | undefined>(undefined)

export const DatabaseProvider = DatabaseContext.Provider

export function useDatabase(): SolaDatabase {
  const db = useContext(DatabaseContext)
  if (db === undefined) {
    throw new Error('useDatabase was called outside DatabaseProvider')
  }
  return db
}
